import { _sharedReducerShare, _sharedStateShare } from "@/shared/store/share/reducer";

export const initialState = _sharedStateShare;

const shareReducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    default:
      return _sharedReducerShare(state, action);
  }
};

export default shareReducer;
